import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_UPDATE_PASSPORT_WITH_OAUTH,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_CODE_CHALLENGE,
    RESPOND_BASE_URL,
    RESPOND_ACCESS_TOKEN,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/powerpointMsgDefinitions";
import {
    PowerPointPassport,
    PowerPointPassportHeader,
    PowerPointPassportID,
    PowerPointPassportAuthCode,
    PowerPointCodeChallenge,
    PowerPointToken,
} from "userful-chronos-app-common-js/dist/models/integration/powerpoint";
import integrationStore from "../integrationStore";
import { powerpointActions } from "../powerpointSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    console.debug("receive POWERBI RESPOND_LIST_PASSPORTS");
    const data = JSON.parse(payload) as PowerPointPassport[];
    integrationStore.dispatch(powerpointActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    console.debug("receive RESPOND_ADD_PASSPORT");
    const data = JSON.parse(payload) as PowerPointPassportHeader;
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
    integrationStore.dispatch(powerpointActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT");
    const data = JSON.parse(payload) as PowerPointPassportHeader;
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
    integrationStore.dispatch(powerpointActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT_WITH_OAUTH");
    const data = JSON.parse(payload) as PowerPointPassportHeader;
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
    integrationStore.dispatch(powerpointActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (data) => {
    integrationStore.dispatch(powerpointActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_REMOVE_PASSPORT");
    const data = JSON.parse(payload) as PowerPointPassportID;
    integrationStore.dispatch(powerpointActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    console.debug("receive NOTIFY_PASSPORT_UPDATE");
    const data = JSON.parse(payload) as PowerPointPassport;
    integrationStore.dispatch(powerpointActions.addOrUpdatePassport(data));
});

registerMsgHandler(RESPOND_CODE_CHALLENGE, (payload) => {
    console.debug("receive RESPOND_CODE_CHALLENGE");
    const data = JSON.parse(payload) as PowerPointCodeChallenge;
    integrationStore.dispatch(powerpointActions.setCodeChallenge(data.codeChallenge));
});

registerMsgHandler(RESPOND_BASE_URL, (payload) => {
    console.debug("receive RESPOND_BASE_URL");
    const data = JSON.parse(payload) as string;
    integrationStore.dispatch(powerpointActions.setBaseURL(data));
});

registerMsgHandler(RESPOND_ACCESS_TOKEN, (payload) => {
    console.debug("receive RESPOND_ACCESS_TOKEN_GRAPH");
    const data = JSON.parse(payload) as PowerPointToken;
    integrationStore.dispatch(powerpointActions.setAccessTokenGraph(data.accessTokenGraph));
    integrationStore.dispatch(powerpointActions.setAccessTokenPowerPoint(data.accessTokenPowerpoint));
});
